import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Label, FormGroup, FormFeedback } from "reactstrap";
import { Field } from "formik";

import pipe from "shared/pipe";
import withErrors from "shared/formik/withErrors";

const FormRowField = ({
  name,
  label,
  labelClassName,
  children,
  tooltipErrors,
  dblockErrors,
  ...props
}) => (
  <Field name={name}>
    {pipe(
      withErrors,
      ({ field, form, fieldErrors }) => (
        <FormGroup {...props}>
          {label && (
            <Label className={classNames("sb-field-label", labelClassName)} for={name}>
              {label}
            </Label>
          )}
          {children({ field, form, ...props })}
          <FormFeedback
            className={classNames({ "d-block": dblockErrors && !!fieldErrors })}
            tooltip={tooltipErrors}
          >
            {fieldErrors}
          </FormFeedback>
        </FormGroup>
      )
    )}
  </Field>
);

FormRowField.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  tooltipErrors: PropTypes.bool,
  dblockErrors: PropTypes.bool
};

FormRowField.defaultProps = {
  label: "",
  labelClassName: "",
  tooltipErrors: false
};

export default FormRowField;
